
export enum NegotiationState {
  Open= 'Open',
  UnderSellerReview= 'UnderSellerReview',
  Closed= 'Closed',
  Unpaid= 'Unpaid',

}